import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router'; // Next.js router
import AuthSwitch from 'components/auth-switch';
import WarningNotification from 'components/warning-notification';
import Panoramic from 'components/analytics/panoramic';
import Header from 'theme/header';
import Body from 'theme/layouts/body';
import Text from 'theme/text';
import translations from 'translations';
import TopBar from 'components/top-bar';
import AnalyticsSubMenu from '../../components/analytics/analytics-sub-menu';

const StyledWarningNotification = styled(WarningNotification)`
  padding: ${themeGet('space.l')}px ${themeGet('space.l')}px 0;
`;

function AnalyticPage() {
  const { languageCode } = useSelector((state) => state.config);
  const router = useRouter(); // Ottieni il router di Next.js

  // Ottieni il valore di dataType dalla query string
  const { dataType } = router.query;

  // Determina l'activeKey in base a dataType
  const activeKey = !dataType || dataType === 'aggregated_data' || dataType === 'temporary_data' ? 'panoramic' : 'confirmed';

  return (
    <AuthSwitch>
      <TopBar />
      <Body bg="primary_50" height="100%" />

      <Header
        bg="white"
        title="StreetLib Analytics"
        style={{
          bg: 'white',
          borderWidth: '0',
          borderBottomWidth: '1px',
          borderColor: 'primary_200',
          borderStyle: 'solid',
        }}
        componentLeft={
          <Text
            ml={[0, 'l', 'l', 'l']}
            fontSize={['h3', 'h2', 'h2', 'h2']}
            lineHeight={['h3', 'h2', 'h2', 'h2']}
            fontWeight="bold"
            color="grey_600"
            textAlign="left"
          >
            {translations[languageCode].analytics}
          </Text>
        }
      />

      {/* Passa l'activeKey calcolato */}
      <AnalyticsSubMenu activeKey={activeKey} />

      <StyledWarningNotification />

      <Panoramic />
    </AuthSwitch>
  );
}

export default AnalyticPage;